import { useState } from "react";
import { FaCheckCircle, FaTimes } from "react-icons/fa";
import { submitForm } from "./utils/api";
import { isValidEmail } from "./utils/validation";

const ContactForm = ({ clientKey, formId }) => {
     const [fieldErrors, setFieldErrors] = useState({});

     const [name, setName] = useState("");
     const [email, setEmail] = useState("");
     const [message, setMessage] = useState("");

     const [loading, setLoading] = useState(false);
     const [success, setSuccess] = useState(null);
     const [error, setError] = useState(null);

     const validate = () => {
          const errors = {};

          const cleanEmail = email?.trim();

          if (cleanEmail && !isValidEmail(cleanEmail)) {
               errors.email = "Please enter a valid email address.";
          }

          setFieldErrors(errors);
          return Object.keys(errors).length === 0;
     };

     const handleSubmit = async (e) => {
          e.preventDefault();

          setLoading(true);
          setSuccess(null);
          setError(null);

          if (!validate()) {
               setError("Please fix the errors above");
               setLoading(false);
               return;
          }

          try {
               const response = await submitForm({
                    client: clientKey,
                    formid: formId,
                    name,
                    email,
                    message,
               });

               if (response.status === 200) {
                    setSuccess("Your details have been submitted successfully!");
               } else {
                    setError("Something went wrong, please try again.");
               }
          } catch (err) {
               setError("Error occurred. Please try again.");
          } finally {
               setLoading(false);
          }
     };

     return (
          <div className="form-container">
               <form onSubmit={handleSubmit} className="form-inner" noValidate>
                    <div className="sect">
                         <label>Name</label>
                         <div className="padder">
                              <input
                                   type="text"
                                   placeholder="enter your name..."
                                   value={name}
                                   onChange={(e) => setName(e.target.value)}
                                   required
                              />
                         </div>
                    </div>

                    <div className="sect">
                         <label>Email Address</label>
                         <div className="padder">
                              <input
                                   type="email"
                                   placeholder="enter your email..."
                                   value={email}
                                   onChange={(e) => setEmail(e.target.value)}
                                   required
                              />
                         </div>
                         {fieldErrors.email && (
                              <span className="error-text">{fieldErrors.email}</span>
                         )}
                    </div>

                    <div className="sect">
                         <label>Message</label>
                         <div className="padder">
                              <textarea
                                   placeholder="start typing your message..."
                                   value={message}
                                   onChange={(e) => setMessage(e.target.value)}
                                   rows="8"
                              />
                         </div>
                    </div>

                    <button disabled={loading}>
                         {loading ? "Sending..." : "Submit"}
                    </button>

                    {success && (
                         <div className="success-message">
                              <FaCheckCircle /> {success}
                         </div>
                    )}

                    {error && (
                         <div className="error-message">
                              <FaTimes /> {error}
                         </div>
                    )}
               </form>
          </div>
     );
};

export default ContactForm;